export const SMALL_DEVICE_MEDIA_SIZE = "md";